import React, { useCallback, useMemo } from 'react';

import { Grid, GridItem } from '@chakra-ui/react';
import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { updateLocalStateValues } from 'components/RabbitOKRSidePanel/KRslice';
import { OKROwnerAndCollaboratorComponent } from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Details/OKROwnerAndCollaborator';
import useOKRConfig from 'components/hooks/useOKRConfig';
import { useSelector, useDispatch } from 'react-redux';
import { kRDrawerSelector } from 'selectors/kRDrawer';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';

import { OBJECTIVE_TYPES_MAP, OKR_TYPES } from 'constants/ProjectConstants';
import { isMobileView } from 'constants/isMobileView';

import { TextLabel } from 'uiToolkitV1/Typography';

interface Props {
  isEditOKR?: boolean;
}

const CollaboratorsSection = ({ isEditOKR }: Props) => {
  const dispatch = useDispatch();
  const createOKRDetails = useSelector(okrCreationPanelStateSelector);
  const editOKRSavedDetails = useSelector(kRDrawerSelector);
  const editOKRDetails = useMemo(
    () => ({ ...editOKRSavedDetails, ...editOKRSavedDetails.localStateValues }),
    [editOKRSavedDetails]
  );
  const okrDetails = isEditOKR ? editOKRDetails : createOKRDetails;

  const { toIds, type } = okrDetails;

  const isObjective = type === OKR_TYPES.OBJECTIVE;

  const { OBJECTIVE_TYPE } = useOKRConfig();

  const isCompactObjectiveType = isObjective && OBJECTIVE_TYPE === OBJECTIVE_TYPES_MAP.COMPACT.value;
  const isDetailedObjectiveType = isObjective && OBJECTIVE_TYPE === OBJECTIVE_TYPES_MAP.DETAILED.value;

  const showOwnersAndCollaborators = !isObjective || isCompactObjectiveType || isDetailedObjectiveType;

  const onChange = useCallback(
    (updates) => {
      dispatch(isEditOKR ? updateLocalStateValues(updates) : updateOKR(updates));
    },
    [dispatch, isEditOKR]
  );

  return (
    <>
      {showOwnersAndCollaborators ? (
        <Grid alignItems="center" gridTemplateColumns={isMobileView() ? '25% 4% 71%' : '20% 4% 76%'} mb="16px">
          <GridItem>
            <TextLabel color="text.g2">Collaborators:</TextLabel>
          </GridItem>
          {/* For spacing after first column */}
          <GridItem />
          <GridItem>
            <OKROwnerAndCollaboratorComponent
              isOwner={false}
              ownersAndCollaborators={toIds}
              // @ts-ignore
              onChange={(toIds) => onChange({ toIds })}
              showSelectEmptyMessage
            />
          </GridItem>
        </Grid>
      ) : null}
    </>
  );
};

export { CollaboratorsSection };
